import * as vp from 'vopay';

import { FunctionComponent } from 'react';
import { Formik } from 'formik';
import buildLoginFormRows from './buildLoginForm.helper';
import type { LoginHandler } from './types';
import { useLayout } from '../../../providers/Layout.provider';

const { Box, Button, ElementContainer, TextField } = vp;

type LoginFormProps = {
  defaultValues: vp.IQ11Login;
  handlers: LoginHandler;
  isSubmitting: boolean;
};

type FC = FunctionComponent<LoginFormProps>;

const LoginForm: FC = (props: LoginFormProps) => {
  const { defaultValues, handlers } = props;
  const { color } = useLayout();
  const loginRow = buildLoginFormRows();

  return (
    <Formik initialValues={defaultValues} onSubmit={handlers.login}>
      {({ touched, errors, handleChange, handleBlur, handleSubmit }) => (
        <form onSubmit={handleSubmit}>
          {loginRow.map(({ label, id, required, preset }) => (
            <ElementContainer
              key={id}
              label={label}
              required={required}
              color="black"
              input={
                <TextField
                  name={id}
                  variant="background"
                  preset={preset}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  error={errors[id] && touched[id] ? errors[id] : null}
                />
              }
            />
          ))}
          <Box mt="md" height="auto">
            <Button
              id="iq11-login-submit"
              label="Sign In"
              type="submit"
              background={color}
              textColor={vp.getContrastColor(color)}
              width="100%"
              size="xlg"
              round
              bold
              noShadow
              textSize={1}
            />
          </Box>
        </form>
      )}
    </Formik>
  );
};

export default LoginForm;
